"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertAlert = void 0;
var tslib_1 = require("tslib");
var sdk_model_1 = require("@gooddata/sdk-model");
var filterContext_1 = require("./filterContext");
exports.convertAlert = function (alert, filterContext) {
    var _a = alert.kpiAlert, _b = _a.content, dashboard = _b.dashboard, isTriggered = _b.isTriggered, kpi = _b.kpi, threshold = _b.threshold, whenTriggered = _b.whenTriggered, _c = _a.meta, uri = _c.uri, identifier = _c.identifier, title = _c.title, summary = _c.summary;
    return tslib_1.__assign(tslib_1.__assign({ title: title, description: summary }, (uri
        ? {
            ref: sdk_model_1.uriRef(uri),
            identifier: identifier,
            uri: uri,
        }
        : {})), { dashboard: sdk_model_1.uriRef(dashboard), widget: sdk_model_1.uriRef(kpi), threshold: threshold,
        whenTriggered: whenTriggered,
        isTriggered: isTriggered, filterContext: filterContext && filterContext_1.convertFilterContext(filterContext) });
};
//# sourceMappingURL=alerts.js.map